<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
        {{ 'DECLINE' | translate }}
    </label>
    <button
        type="button"
        class="btn-close btn-close-white shadow-none crossButtonPosition"
        [mat-dialog-close]></button>
</div>

<mat-dialog-content class="contentPadding">
    <form [formGroup]="declineFormGroup">
        <mat-form-field class="w-100 notes-container" appearance="outline">
            <mat-label class="bold">
                {{ 'PUBLISH_CHANGE_LOG_NOTES' | translate }}
            </mat-label>

            <textarea
                matInput
                formControlName="declineNotes"
                placeholder="{{ 'PUBLISH_CHANGE_LOG_NOTES_PLACEHOLDER' | translate }}">
            </textarea>

            @if (declineFormGroup.controls.declineNotes.hasError('required')) {
                <mat-error>{{ 'NOTES_ARE_REQUIRED' | translate }}</mat-error>
            }
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="actionsPadding">
    <div>
        <button
            class="openCloseBtn"
            mat-raised-button
            color="primary"
            (click)="decline()"
            [disabled]="declineFormGroup.invalid">
            {{ 'DECLINE' | translate }}
        </button>

        <button
            class="openCloseBtn"
            mat-raised-button
            color="warn"
            [mat-dialog-close]>
            {{ 'CANCEL' | translate }}
        </button>
    </div>
</mat-dialog-actions>